import { useEffect } from 'react';
import { useNavigate } from '@/lib/router-compat';
import { useCountry } from '@/hooks/useCountry';

/**
 * Redirects UK / DE visitors to the localized homepage when they land on a
 * page that is only available in Romanian. Add this at the top of any page
 * that hasn't been translated yet:
 *
 *   const blocked = useRoOnlyGuard();
 *   if (blocked) return null;
 *
 * Remove the guard once the page is fully translated for EN (UK) and DE.
 */
export function useRoOnlyGuard(): boolean {
  const { country } = useCountry();
  const navigate = useNavigate();

  useEffect(() => {
    if (country === 'UK') navigate('/uk', { replace: true });
    else if (country === 'DE') navigate('/de', { replace: true });
  }, [country, navigate]);

  return country === 'UK' || country === 'DE';
}
